import React, { useState } from "react";
import Api from "../../Api";
import "./deleteGuestModal.css";

const DeleteGuestModal = ({ guest, onClose, onDeleted }) => {
	// ============================================================
	// STATE
	// ============================================================
	const [isDeleting, setIsDeleting] = useState(false);

	// ============================================================
	// SAFETY GUARD
	// Falls aus irgendeinem Grund kein Gast vorhanden ist,
	// rendern wir das Modal lieber gar nicht.
	// ============================================================
	if (!guest) {
		return null;
	}

	// ============================================================
	// DELETE HANDLER
	// ============================================================
	const handleDelete = async () => {
		setIsDeleting(true);

		try {
			await Api.delete(`/guests/${guest.guestId}`);
			onDeleted?.();
		} catch (err) {
			console.error(err);
			alert("Fehler beim Löschen des Gastes.");
			setIsDeleting(false);
		}
	};

	// ============================================================
	// RENDER
	// - Klick auf Overlay = Modal schliessen
	// - Klick auf Content = NICHT schliessen
	// ============================================================
	return (
		<div
			className="modal-overlay"
			onClick={onClose}
		>
			<div
				className="modal-content danger"
				onClick={(e) => e.stopPropagation()}
			>
				<h3>Gast löschen</h3>

				<p>
					Möchtest du den Gast
					<br />
					<strong>
						{guest.firstName} {guest.lastName}
					</strong>
					<br />
					wirklich löschen?
				</p>

				<div className="modal-buttons">
					<button
						className="btn-danger"
						onClick={handleDelete}
						disabled={isDeleting}
						type="button"
					>
						{isDeleting ? "Lösche…" : "Löschen"}
					</button>

					<button
						className="btn-secondary"
						onClick={onClose}
						disabled={isDeleting}
						type="button"
					>
						Abbrechen
					</button>
				</div>
			</div>
		</div>
	);
};

export default DeleteGuestModal;